import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
// the main entry appends its own stylesheet to <head>, after index.css, and wins over our overrides
import { ToastContainer } from 'react-toastify/unstyled';
import { baseURL } from 'app-constants.ts';
import { Provider } from 'jotai';
import { routes } from 'routes.tsx';

import { markNewVersion } from 'Helpers/hooks/useHasNewVersion.ts';
import { reloadOnMissingChunk } from 'Helpers/reloadOnMissingChunk.ts';
import { watchForNewVersion } from 'Helpers/watchForNewVersion.ts';
import { captureAttribution } from 'Services/attribution';
import { gtm } from 'Services/gtm';
import { analytics } from 'Services/mixpanel';
import { sentryInit } from 'Services/sentry';
import { showNewVersionToast } from 'Components/alerts/NewVersionToast.tsx';
// import { StrictMode } from 'react';

import './index.css';

reloadOnMissingChunk();
// Static import on purpose: after a deploy the old build's lazy chunks are gone from the CDN, so a
// lazy toast would fail to load in the tab that needs it.
watchForNewVersion(import.meta.env.BUILD_TS, (deployedBuildTs) => {
    markNewVersion();
    showNewVersionToast(deployedBuildTs);
});
analytics.load();
gtm.load();
const { sentryCreateBrowserRouter } = sentryInit();
captureAttribution();
console.info(import.meta.env.PACKAGE_VERSION);

ReactDOM.createRoot(document.getElementById('root')!).render(
    // <StrictMode>
    <Provider>
        <RouterProvider
            router={sentryCreateBrowserRouter(routes, {
                basename: baseURL.pathname,
            })}
            // Runs route changes as a transition, so a page suspending on its chunk keeps the
            // current one on screen instead of dropping to the Suspense fallback.
            future={{ v7_startTransition: true }}
        />
        <ToastContainer autoClose={3e3} icon={false} closeOnClick />
    </Provider>
    //</StrictMode>
);
